import styled from 'styled-components'

export const Button = styled.button`
  outline-color: #002d63;
  width: 96px;
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  background-color: #f44336;
  flex: 1;

  :disabled {
    background-color: #c7c9c7;
  }
`

export const Text = styled.p`
  font-size: 16px;
  margin: 0;
  height: 100%;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`
